export default {
	Prayers: {
		SIGNUM_CRUCIS: 'In nomine Patris et Filii et Spiritus Sancti. Amen.',
		APOSTLES_CREED: 'Credo in Deum, Patrem omnipotentem, creatorem caeli et terrae. Et in Iesum Christum, Filium eius unicum, Dominum nostrum, qui conceptus est de Spiritu Sancto, natus ex Maria Virgine, passus sub Pontio Pilato, crucifixus, mortuus et sepultus. Descendit ad inferos, tertia die resurrexit a mortuis. Ascendit ad caelos, sedet ad dextram Dei Patris omnipotentis. Inde venturus est iudicare vivos et mortuos. Credo in Spiritum Sanctum, sanctam Ecclesiam catholicam, sanctorum communionem, remissionem peccatorum, carnis resurrectionem, vitam aeternam. Amen.',
		PATER_NOSTER: 'Pater noster, qui es in caelis: Sanctificetur nomen tuum: Adveniat regnum tuum: Fiat voluntas tua, sicut in caelo, et in terra. Panem nostrum quotidianum da nobis hodie: Et dimitte nobis debita nostra, sicut et dimittimus debitoribus nostris. Et ne nos inducas in tentationem, sed libera nos a malo. Amen.',
		AVE_MARIA: 'Ave Maria, gratia plena: Dominus tecum, benedicta tu in mulieribus, et benedictus fructus ventris tui, Iesus. Sancta Maria, Mater Dei, ora pro nobis peccatoribus, nunc et in hora mortis nostrae. Amen.',
		GLORIA: 'Gloria Patri, et Filio, et Spiritui Sancto. Sicut erat in principio, et nunc, et semper, et in saecula saeculorum. Amen.',
		ORATIO_FATIMA: 'Domine Iesu, dimitte nobis debita nostra, salva nos ab igne inferiori, perduc in caelum omnes animas, praesertim eas quae misericordiae tuae maximae indigent.',
		SALVE_REGINA: 'Salve, Regina, mater misericordiae; vita, dulcedo et spes nostra, salve. Ad te clamamus exsules filii Hevae. Ad te suspiramus gementes et flentes in hac lacrimarum valle. Eia ergo, advocata nostra, illos tuos misericordes oculos ad nos converte. Et Iesum, benedictum fructum ventris tui, nobis post hoc exsilium ostende. O clemens, o pia, o dulcis Virgo Maria. Ora pro nobis, sancta Dei Genetrix, ut digni efficamur promissionibus Christi.'
	},

	Ordinals: {
		MYSTERY_1: 'Primum mysterium',
		MYSTERY_2: 'Secundum mysterium',
		MYSTERY_3: 'Tertium mysterium',
		MYSTERY_4: 'Quartum mysterium',
		MYSTERY_5: 'Quintum mysterium'
	},

	Mysteries: {
		JOYFUL: {
			MYSTERY_1: 'Annuntiatio Gabrielis Archangeli ad Beatam Mariam Virginem',
			MYSTERY_2: 'Visitatio Beatae Mariae Virginis ad Elisabeth',
			MYSTERY_3: 'Nativitas Domini Nostri Iesu Christi',
			MYSTERY_4: 'Presentatio Iesu Infantis in templo',
			MYSTERY_5: 'Inventio Iesu in templo'
		},
		SORROWFUL: {
			MYSTERY_1: 'Agonia Iesu in horto Gethsemanie',
			MYSTERY_2: 'Flagellatio Iesu',
			MYSTERY_3: 'Coronatio Iesu spinis',
			MYSTERY_4: 'Portatio crucis suae a Iesu',
			MYSTERY_5: 'Crucifixio Iesu'
		},
		GLORIOUS: {
			MYSTERY_1: 'Resurrectio Iesu',
			MYSTERY_2: 'Eius in caelum ascensio',
			MYSTERY_3: 'Descensio Sancti Spiritus super Mariam et Apostolos',
			MYSTERY_4: 'Assumptio Beatae Mariae Virginis in caelum',
			MYSTERY_5: 'Coronatio Beatae Mariae Virginis in reginam caeli'
		},
		LUMINOUS: {
			MYSTERY_1: 'Baptisma in flumine Iordano',
			MYSTERY_2: 'Revelatio sui ipsius ad nuptias Cananenses',
			MYSTERY_3: 'Regni Dei proclamatio simul cum invitatio ad conversionem',
			MYSTERY_4: 'Transfiguratio',
			MYSTERY_5: 'Eucharistiae institutio'
		}
	}
};
